import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Core from './Core';

var destination = document.querySelector('#container');


ReactDOM.render(

	<div className="main">
	<Core />
	</div>,
	destination
);



// WEBPACK FOOTER //
// ./src/index.js